module.exports = __webpack_public_path__ + "static/media/qrcode-wechat.ee8e3f58.jpg";